import React from 'react';
import AuthCardLayout from 'layouts/AuthCardLayout';
import WaitlistStatusCheck from './components/WaitlistStatusCheck';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const WaitlistStatus = () => {
  const { t } = useTranslation();
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="pt-3 text-white">
          {t('WAITLIST.WANT_TO_JOIN')}
          <br />
          <Button
            as={Link}
            variant="outline-light"
            className="mt-2 px-4"
            to="/waitlist"
          >
            {t('WAITLIST.APPLY_NOW')}
          </Button>
        </p>
      }
      footer={false}
    >
      <h3>{t('WAITLIST.STATUS_TITLE')}</h3>
      <p className="text-muted mb-4">
        {t('WAITLIST.STATUS_SUBTITLE')}
      </p>
      <WaitlistStatusCheck />
    </AuthCardLayout>
  );
};

export default WaitlistStatus;
